import QuizStepPage from './QuizStepPage';
export default QuizStepPage;